var map = {
	"./banner/hero-banner-desktop.jpg": "4d88",
	"./banner/hero-banner.jpg": "8a7a",
	"./icons/ageing-0.svg": "1846",
	"./icons/ageing.svg": "0c14",
	"./icons/alone.svg": "a0b0",
	"./icons/babies.svg": "69c7",
	"./icons/condo.svg": "f35b",
	"./icons/education.svg": "ef70",
	"./icons/household.svg": "6bb3",
	"./icons/income.svg": "a4d5",
	"./icons/religio-00.svg": "5f37",
	"./icons/religion.svg": "bd06",
	"./icons/single.svg": "653f",
	"./icons/work.svg": "c8aa",
	"./scrolly-ageing/big.svg": "508f",
	"./scrolly-ageing/desktop.svg": "cc5c",
	"./scrolly-ageing/mobile.svg": "d75b",
	"./scrolly-ageing/tablet.svg": "5501",
	"./scrolly-test/1-desktop.jpg": "34a3",
	"./scrolly-test/1.jpg": "f822",
	"./scrolly-test/2-desktop.jpg": "759f",
	"./scrolly-test/2.jpg": "2b07",
	"./scrolly-test/3-desktop.jpg": "47ad",
	"./scrolly-test/3.jpg": "6987",
	"./scrolly-test/4-desktop.jpg": "2564",
	"./scrolly-test/4.jpg": "8b6d",
	"./scrolly-v2/big.svg": "7586",
	"./scrolly-v2/desktop.svg": "a85b",
	"./scrolly-v2/mobile.svg": "ccbb",
	"./scrolly-v2/tablet.svg": "80b2",
	"./slope-aging/desktop.svg": "7a09",
	"./slope-aging/mobile.svg": "d336",
	"./slope-aging/tablet.svg": "3620",
	"./slope-babies/desktop.svg": "5207",
	"./slope-babies/mobile.svg": "75ab",
	"./slope-babies/tablet.svg": "8f78",
	"./slope-condos/desktop.svg": "1b75",
	"./slope-condos/mobile.svg": "f191",
	"./slope-condos/tablet.svg": "d137",
	"./slope-education/desktop.svg": "2edb",
	"./slope-education/mobile.svg": "eff2",
	"./slope-education/tablet.svg": "89d2",
	"./slope-income/desktop.svg": "d905",
	"./slope-income/mobile.svg": "17fd",
	"./slope-income/tablet.svg": "00a3",
	"./slope-religion/desktop.svg": "7d4d",
	"./slope-religion/mobile.svg": "72b8",
	"./slope-religion/tablet.svg": "8fc7",
	"./slope-single/desktop.svg": "a1a3",
	"./slope-single/mobile.svg": "d3a8",
	"./slope-single/tablet.svg": "b873",
	"./slope-size/desktop.svg": "d916",
	"./slope-size/mobile.svg": "6f98",
	"./slope-size/tablet.svg": "ab94",
	"./slope-working-2/desktop.svg": "2f68",
	"./slope-working-2/mobile.svg": "c856",
	"./slope-working-2/tablet.svg": "0454",
	"./slope-working/desktop.svg": "4d25",
	"./slope-working/mobile.svg": "15b0",
	"./slope-working/tablet.svg": "0f1b",
	"./template/image-background-header-desktop.jpg": "5c5b",
	"./template/image-background-header.jpg": "32e0",
	"./template/sample-image-desktop.png": "3100",
	"./template/sample-image.png": "da96",
	"./template/sample-logo.svg": "2bfb",
	"./test/household-sample-slope-desktop.png": "7602",
	"./test/household-sample-slope.png": "c3c3",
	"./test/sample-ageing-2-desktop.png": "2ce1",
	"./test/sample-ageing-2.png": "c9f5",
	"./test/sample-ageing-desktop.png": "2f58",
	"./test/sample-ageing.png": "5522",
	"./test/sample-transport-desktop.png": "fc4f",
	"./test/sample-transport.png": "67f1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8453";